<template>
  <InputComponent v-bind="$attrs" :value="value">
    <template #default="{ onBlur, onFocus }">
      <textarea
        v-model="comp"
        class="elder-input__element"
        ref="el"
        v-bind="$attrs"
        :style="{ resize: 'vertical' }"
        @focus="onFocus"
        @blur="onBlur"
      />
    </template>
  </InputComponent>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import { ValueComp } from '../utils'

export default {
  props: ['value'],
  computed: {
    comp: ValueComp(),
  },
  components: {
    InputComponent,
  },
}
</script>
